export default __webpack_public_path__ + "c70a95230c9c0dcd8c6f7344824aad1e.svg";